import './style/index.js';

import _Progress from './progress';

export type { ProgressProps } from './progress';
export const Progress = _Progress;
export default Progress;

export * from './type';
